import styled from 'styled-components'

export const BoardContainer = styled.div<{ componentStyle?: string }>`
    ${(props) => props.componentStyle}
    border: var(--dashboard-default-border);
    border-radius: var(--dashboard-border-radius);
    display: grid;
    background-color: var(--dashboard-basic-background-color);
    grid-template-columns: 1fr 1fr;
    h5 {
        text-align: center;
        margin: var(--dashboard-default-gap) 0;
        line-height: 25px;
        small {
            display: block;
            font-style: italic;
        }
    }
    footer {
        border-top: var(--dashboard-default-border);
        color: var(--dashboard-main-color);
        background-color: var(--dashboard-main-color-light);
        border-bottom-left-radius: var(--dashboard-border-radius);
        border-bottom-right-radius: var(--dashboard-border-radius);
        grid-area: 2 / 1 / 2 / 3;
        padding: 10px;
        display: flex;
        align-items: center;
        justify-content: space-around;
        h5 {
            font-size: 20px;
            width: 250px;
            text-align: left;
            padding-left: 30px;
        }
        .stat {
            flex-grow: 1;
            b {
                display: block;
                font-weight: normal;
            }
            strong {
                font-size: 2em;
                margin-right: 10px;
                font-weight: 600;
                line-height: 25px;
            }
            span {
                font-style: italic;
            }
        }
    }
    &:hover {
        box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
    animation: fadeIn 0.5s ease-in-out;
    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translate(0, -10px);
        }
        to {
            opacity: 1;
            transform: translate(0, 0);
        }
    }
`
export const BoardStatistics = styled.div`
    grid-area: 1 / 1 / 1 / 2;
    border-right: var(--dashboard-default-border);
    min-height: 300px;
`
export const BoardStats = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    margin-bottom: var(--dashboard-default-gap);
`

export const BoardStat = styled.div`
    padding: 0 10px;
    margin: 0 30px;
    flex-grow: 1;
    border-bottom: var(--dashboard-default-border);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    strong {
        font-size: 28px;
        font-weight: bold;
        display: block;
    }
    span {
        font-size: 11px;
    }
    &:first-child {
        color: var(--dashboard-main-color);
        border-bottom: none;
        grid-area: 1 / 1 / 3 / 2;
        border-right: var(--dashboard-default-border);
        margin-right: 0;
        strong {
            font-size: 9em;
            line-height: 120px;
        }
        span {
            font-size: 2em;
        }
    }
    &:last-child {
        border-right: none;
        border-bottom: none;
    }
`
export const BoardGoals = styled.div`
    text-align: center;
    font-size: 0.85em;
`

export const BoardChart = styled.div`
    grid-area: 1 / 2 / 1 / 3;
    padding: 10px;
    height: 200px;
    small {
        color: var(--dashboard-black-color);
        font-style: normal;
        font-size: 12px;
    }
    tspan {
        font-size: 9px;
        text-transform: uppercase;
    }
`
